module.exports = __webpack_public_path__ + "static/media/Hexa.0ce4da54.png";